@if (uiService.isCheckOutViewMinimized) {
  <div matTooltip="Expand Check Out View" (click)="uiService.isCheckOutViewMinimized = !uiService.isCheckOutViewMinimized" class="case-view-collapsed" data-cy="check-out-collapsed">
    <div style="display: flex; flex-direction: column;" data-cy="check-out-collapsed-container">
      <lucide-icon name="chevron-right" [size]="20" data-cy="check-out-collapsed-chevron"></lucide-icon>
      <div style="color: var(--tdo-primary-accent);" data-cy="check-out-collapsed-icon"><lucide-icon name="badge-check" [size]="20"></lucide-icon></div>
      <div style="transform: rotate(-90deg); font-size: 10px; line-height: 5; font-weight: 700; vertical-align: top" data-cy="check-out-collapsed-text">CHECK OUT</div>
    </div>
  </div>
}
@if (!uiService.isCheckOutViewMinimized) {
  <div style="width: 282px; display: flex; flex-direction: column; height: 100%; overflow-y: hidden;" data-cy="check-out-expanded"> <!--!-->
    <div style="flex-basis: 250px; max-height: 650px; display: flex; flex-direction: column;" data-cy="check-out-main-container">
      <div style="flex-basis: fit-content;" data-cy="check-out-header-container">
        <div style="display: flex; background-color: var(--tdo-purple-light)" data-cy="check-out-title-bar">
          <div style="cursor: pointer; position: relative; right: -6px; color: black; font-weight: 500;"
            (click)="uiService.isCheckOutViewMinimized = !uiService.isCheckOutViewMinimized" data-cy="check-out-collapse-btn">
            <lucide-icon name="chevron-left" [size]="20" style="position: absolute; right: -10px; color: white" matTooltip="Collapse Check Out View"></lucide-icon>
          </div>
          <span style="margin-left: 10px;color: white" data-cy="check-out-title"><b>Check Out</b></span>
        </div>
        @if (isLoadingCheckOutData) {
          <mat-progress-bar mode="indeterminate" data-cy="check-out-loading-bar"></mat-progress-bar>
        }
        <!--<div style="flex-basis: 250px; max-height: 450px; display: flex; flex-direction: column;">!-->
        <div style="display:flex;flex-direction: column; height: 100px; width: 270px; padding-top: 10px; margin: 5px 10px 10px;" data-cy="check-out-summary-container">
          <div style="vertical-align: center" data-cy="check-out-notes-btn-container">
            <button mat-button class="tdo-button tdo-save" style="width: 90%; margin-left: 15px; background-color: var(--tdo-blue-active)" (click)="showNotesToFront()" data-cy="check-out-notes-btn">Show Notes To Front</button>
          </div>
          <div style="justify-content: space-between;display: inline-block; margin-top: 5px;  width: 90%; margin-left: 15px; background-color: var(--tdo-purple-light);" data-cy="check-out-summary-info">
            @if (checkOutInformation) {
              <span data-cy="check-out-total-debit">Total Debit: {{checkOutInformation.TotalDebit | currency }}</span>
            }
            <br/>
            @if (checkOutInformation) {
              <span data-cy="check-out-balance">Balance: {{checkOutInformation.TotalBalance | currency }}</span>
            }
          </div>
          @if (!checkOutInformation) {
            <mat-progress-bar mode="indeterminate" style="justify-content: space-between;display: inline-block; width: 90%; margin-left: 15px;" data-cy="check-out-summary-loading"></mat-progress-bar>
          }
        </div>
        <div style="display:flex;flex-direction: column; height: 460px; width: 270px; padding-top: 10px;margin-right: 10px; margin-left: 10px; border: solid 1px var(--tdo-blue-light);" data-cy="check-out-procedures-container">
          <div style="vertical-align: center" data-cy="check-out-form-container">
            <form [formGroup]="myForm" data-cy="check-out-form">
              <div formArrayName="checkOutProcedure" class="example-list" data-cy="check-out-procedure-list">
                @for (procedure of checkOutProcedureForms.controls; track procedure; let i = $index) {
                  <div [formGroupName]="i" class="row example-box" data-cy="check-out-procedure-item">
                    <div class="iconDiv" data-cy="check-out-procedure-icon-container">
                      <mat-icon aria-hidden="false" class="icon" [hidden]="!icon[i].show" matTooltip="{{icon[i].toolTip}}" data-cy="check-out-procedure-icon">{{icon[i].name}}</mat-icon>
                    </div>
                    <div style="width: 60%; align-content: center" data-cy="check-out-procedure-btn-container">
                      <button mat-button class="tdo-button tdo-save" style="width: 100%; align-content: center" (click)="AddFunction(buttonAction[i],i)" data-cy="check-out-procedure-btn">{{selectedCheckOutTask[i].ItemDisplayValue}}</button>
                    </div>
                    <div class="iconDiv" data-cy="check-out-procedure-done-container">
                      <lucide-icon name="check-circle" [size]="20" aria-hidden="false" class="icon" [hidden]="actionDone[i]" data-cy="check-out-procedure-done-icon"></lucide-icon>
                    </div>
                  </div>
                }
              </div>
            </form>
          </div>
          <div style="padding-top: 10px" data-cy="check-out-next-btn-container">
            <!--<button mat-button class="tdo-button tdo-save" style="width: 100%">Next</button>!-->
            <button mat-button class="tdo-button tdo-save" style="width: 90%; margin-left: 15px; background-color: var(--tdo-blue-active)" (click)="executeNextStep()" data-cy="check-out-next-btn">Next</button>
          </div>
        </div>
        @if (!checkOutInformation) {
          <mat-progress-bar mode="indeterminate" style="justify-content: space-between;display: inline-block; width: 270px; margin-left: 10px;" data-cy="check-out-procedures-loading"></mat-progress-bar>
        }
      <!--</div>!-->
      <div style="display:flex;flex-direction: column; height: 100px; width: 270px; padding-top: 10px;margin-right: 10px; margin-left: 10px; margin-bottom: 10px;" data-cy="check-out-close-container">
        <div style="vertical-align: center" data-cy="check-out-close-btn-container">
          <button mat-button class="tdo-button tdo-save" style="width: 60%; margin-left: 65px; background-color: var(--tdo-blue-active)" (click)="closeCheckOutView()" data-cy="check-out-close-btn">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
}



